import { render, staticRenderFns } from "./FilePreview.vue?vue&type=template&id=d758d9a4&"
import script from "./FilePreview.vue?vue&type=script&lang=js&"
export * from "./FilePreview.vue?vue&type=script&lang=js&"
import style0 from "./FilePreview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports